/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Container = styled.div`
  position: relative;
`;

export const MyTextArea = styled.textarea`
  width: 100%;
  font-size: 14px;
  resize: none;
  color: ${() => Palette.PrimaryGray._900};
  line-height: 20px;
  font-weight: normal;
  padding: 15px;
  padding-right: 30px;
  box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.04);
  border-radius: 4px;
  outline: none;
  border: 1px solid ${() => Palette.PrimaryGray._200};
  background: ${() => Palette.PrimaryGray._000};
  transition: 0.2s ease-in-out;
  &:hover {
    border: 1px solid ${() => Palette.PrimaryGray._300};
  }
  &:focus {
    background: #ffffff;
    border: 1px solid ${() => Palette.Primary._300};
    box-shadow: 0px 0px 0px 3px rgba(59, 137, 246, 0.16), inset 0px 2px 4px rgba(0, 0, 0, 0.04);
    border-radius: 4px;
  }
  &:disabled {
    opacity: 0.5;
    border: 1px solid ${() => Palette.PrimaryGray._300};
    color: ${() => Palette.Gray._400};
    &:hover {
      border: 1px solid ${() => Palette.PrimaryGray._300};
    }
  }
  ${({ error }) =>
    error &&
    css`
      background: ${() => Palette.PrimaryGray._000};
      border: 1px solid ${() => Palette.Red._300};
    `}
`;

export const DisadledIcon = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 15px;
  opacity: 0.5;
`;

export const Error = styled.div`
  display: inline-flex;
  align-items: center;
  margin-top: 4px;
  svg {
    height: 16px;
    min-width: 16px;
    max-width: 16px;
  }
  span {
    color: ${() => Palette.Red._700};
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    margin-left: 8px;
  }
`;

export const RightIconWrap = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
`;
